<template>
  <div style="height: 100%;">
    <transition name="router-fade" mode="out-in">
        <router-view></router-view>
    </transition>
  </div>
</template>

<script>
    export default {
		data() {
			return {
				
			}
		},
		components: {
		}
    }

</script>

<style lang="scss">
  .router-fade-enter-active, .router-fade-leave-active {
      transition: opacity .3s;
  }
  .router-fade-enter, .router-fade-leave-active {
      opacity: 0;
  }
</style>
